import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f3c1b1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 mb-2" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-2 col-6 ps-3" }
const _hoisted_4 = {
  key: 0,
  class: "col-12 wrapper bg-light p-3 mt-3 mb-2"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "col-6 mb-2" }
const _hoisted_8 = { class: "mb-2 col-2" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_11 = { class: "col-12 wrapper bg-light p-3 pb-2 mt-3 mb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = { class: "col-6 mb-2" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_17 = {
  key: 0,
  class: "col-12 mb-2"
}
const _hoisted_18 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "mb-2" }
const _hoisted_24 = { class: "table-wrapper" }
const _hoisted_25 = { class: "table-scroll mb-2" }
const _hoisted_26 = { class: "table align-middle mt-4" }
const _hoisted_27 = {
  type: "submit",
  class: "btn btn-primary ms-2"
}
const _hoisted_28 = { class: "col-12 wrapper bg-light p-3 pb-2 mt-3 mb-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_input_radio = _resolveComponent("input-radio")!
  const _component_input_file = _resolveComponent("input-file")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { "container-fluid": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('import'),
        mb: 2,
        "back-route": {name: 'pim-products-overview'},
        "help-text": _ctx.$t('descriptionImportCSV')
      }, null, 8, ["title", "help-text"]),
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_component_GenericFormWrapper, {
          submitData: _ctx.submitSelection,
          pageUI: _ctx.pageUI,
          hideButtons: true,
          buttonClass: "btn-sm"
        }, {
          content: _withCtx(({errors}) => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('fileType')), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_input_radio, {
                id: "fileTypeCsv",
                label: _ctx.$t('csv'),
                name: "fileType",
                errors: errors,
                rules: "required",
                value: "csv",
                modelValue: _ctx.selectedFileType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFileType) = $event))
              }, null, 8, ["label", "errors", "modelValue"]),
              _createVNode(_component_input_radio, {
                id: "fileTypeXlsx",
                label: _ctx.$t('xlsx'),
                name: "fileType",
                errors: errors,
                rules: "required",
                value: "xlsx",
                modelValue: _ctx.selectedFileType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFileType) = $event))
              }, null, 8, ["label", "errors", "modelValue"])
            ]),
            (_ctx.selectedFileType === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('importPimFileTypeText1')), 1),
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('importFileTypeText2')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_input_file, {
                  modelValue: _ctx.prepareCsvHandlingRequest.document_key,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.prepareCsvHandlingRequest.document_key) = $event)),
                  label: _ctx.$t('csvFile'),
                  name: _ctx.$t('csvFile'),
                  rules: _ctx.selectedFileType === 'csv' ? 'required' : '',
                  errors: errors,
                  "allowed-extensions": ['csv'],
                  module: _ctx.DpModuleEnum.CPC,
                  useSignedUrl: true,
                  "type-code": "CSV_UPLOAD_PIM_PRODUCT_INFO",
                  onExceptions: _ctx.setErrorMessage
                }, null, 8, ["modelValue", "label", "name", "rules", "errors", "module", "onExceptions"])
              ]),
              (_ctx.prepareCsvHandlingRequest.document_key)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_input_text, {
                        modelValue: _ctx.prepareCsvHandlingRequest.csv_metadata.delimiter,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.prepareCsvHandlingRequest.csv_metadata.delimiter) = $event)),
                        label: _ctx.$t('separator'),
                        name: _ctx.$t('separator'),
                        rules: _ctx.selectedFileType === 'csv' ? 'required' : '',
                        errors: errors
                      }, null, 8, ["modelValue", "label", "name", "rules", "errors"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_input_checkbox_boolean, {
                        modelValue: _ctx.prepareCsvHandlingRequest.csv_metadata.has_header,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prepareCsvHandlingRequest.csv_metadata.has_header) = $event)),
                        label: _ctx.$t('hasHeader'),
                        name: _ctx.$t('hasHeader'),
                        errors: errors
                      }, null, 8, ["modelValue", "label", "name", "errors"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.$t('next')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('importFileCSVText1')), 1),
                        _hoisted_12,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('importFileCSVText2')), 1)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.selectedFileType === 'csv']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_input_file, {
                  modelValue: _ctx.prepareXlsxHandlingRequest.document_key,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.prepareXlsxHandlingRequest.document_key) = $event)),
                  label: _ctx.$t('xlsxFile'),
                  name: _ctx.$t('xlsxFile'),
                  rules: _ctx.selectedFileType === 'xlsx' ? 'required' : '',
                  errors: errors,
                  "allowed-extensions": ['xlsx'],
                  module: _ctx.DpModuleEnum.CPC,
                  useSignedUrl: true,
                  "type-code": "XLSX_UPLOAD_PIM_PRODUCT_INFO",
                  onExceptions: _ctx.setErrorMessage
                }, null, 8, ["modelValue", "label", "name", "rules", "errors", "module", "onExceptions"])
              ]),
              (_ctx.prepareXlsxHandlingRequest.document_key)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_input_checkbox_boolean, {
                        modelValue: _ctx.prepareXlsxHandlingRequest.xlsx_metadata.has_header,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.prepareXlsxHandlingRequest.xlsx_metadata.has_header) = $event)),
                        label: _ctx.$t('hasHeader'),
                        name: _ctx.$t('hasHeader'),
                        errors: errors
                      }, null, 8, ["modelValue", "label", "name", "errors"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.$t('next')), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.selectedFileType === 'xlsx']
            ])
          ]),
          _: 1
        }, 8, ["submitData", "pageUI"])
      ], 512), [
        [_vShow, _ctx.step === 'selection']
      ]),
      (_ctx.step === 'mapping')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            (_ctx.selectedFileType === 'csv')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.$t('fileType')) + ": " + _toDisplayString(_ctx.$t('csv')), 1),
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('separator')) + ": " + _toDisplayString(_ctx.prepareCsvHandlingRequest.csv_metadata.delimiter), 1),
                  _hoisted_20,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('hasHeader')) + ": " + _toDisplayString(_ctx.prepareCsvHandlingRequest.csv_metadata.has_header ? _ctx.$t('yes') : _ctx.$t('no')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_ctx.$t('fileType')) + ": " + _toDisplayString(_ctx.$t('xlsx')), 1),
                  _hoisted_22,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('hasHeader')) + ": " + _toDisplayString(_ctx.prepareXlsxHandlingRequest.xlsx_metadata.has_header ? _ctx.$t('yes') : _ctx.$t('no')), 1)
                ])),
            (_ctx.prepareImportHandlingResponse)
              ? (_openBlock(), _createBlock(_component_GenericFormWrapper, {
                  key: 2,
                  submitData: _ctx.submitMapping,
                  pageUI: _ctx.pageUI,
                  hideButtons: true,
                  buttonClass: "btn-sm"
                }, {
                  content: _withCtx(({errors}) => [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("table", _hoisted_26, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prepareImportHandlingResponse.headers, (header, index) => {
                                  return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(header), 1))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prepareImportHandlingResponse.preview_rows, (row, rowIndex) => {
                                return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.columns, (column, columnIndex) => {
                                    return (_openBlock(), _createElementBlock("td", { key: columnIndex }, _toDisplayString(column), 1))
                                  }), 128))
                                ]))
                              }), 128)),
                              _createElementVNode("tr", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prepareImportHandlingResponse.headers, (_, index) => {
                                  return (_openBlock(), _createElementBlock("td", { key: index }, [
                                    _createVNode(_component_input_select, {
                                      modelValue: _ctx.mappedColumns[index].column_type_code,
                                      "onUpdate:modelValue": [($event: any) => ((_ctx.mappedColumns[index].column_type_code) = $event), ($event: any) => (_ctx.mappedColumnUpdated(index))],
                                      name: 'column_type_' + index,
                                      options: _ctx.prepareImportHandlingResponse.supported_columns,
                                      errors: errors,
                                      canClear: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options", "errors"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
                          }, _toDisplayString(_ctx.$t('back')), 1),
                          _createElementVNode("button", _hoisted_27, _toDisplayString(_ctx.$t('import')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('importFileMappingText1')), 1),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('importFileMappingText2')), 1),
                          _hoisted_29,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('importFileMappingText3')), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('importFileMappingText4')), 1),
                          _hoisted_30,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('importFileMappingText5')), 1)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('importFileMappingText6')), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["submitData", "pageUI"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}